// File: src/MathPractice/TrigGraphPractice.js

import SinusoidToolPractice from "./SinusoidToolPractice";

export default function TrigGraphPractice() {
  return (
    <div style={{ padding: 24 }}>
      <h1>Trig Graph Practice</h1>
      <SinusoidToolPractice />
    </div>
  );
}
